// Styles
import "./login.scss";
// Tools
import { useState, useRef, useEffect, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// Components
import { Button } from "../../../../shared/components/buttons/Button";
import { InputEmail } from "../../../../shared/components/inputs/InputEmail";
import { InputPassword } from "../../../../shared/components/inputs/InputPassword";
import { CircleLoader } from "../../../../shared/components/circle-loader/CircleLoader";
import { MainMessage } from "../../../../shared/components/messages/MainMessage";
// Utils
import { showElement } from "../../../../shared/ui/gsap-animations/show-element";
import { hideElement } from "../../../../shared/ui/gsap-animations/hidden-element";
// Services
import { loginRequest } from "./service/login.service";

export const Login = () => {
	// ---------------- Navigation
	const navigate = useNavigate();

	// ---------------- Refs
	const loaderRef = useRef<HTMLDivElement>(null);
	const messageRef = useRef<HTMLDivElement>(null);

	// ---------------- States
	const [email, setEmail] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
	const [isFormValid, setIsFormValid] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>("");

	// ---------------- Functions
	// Обработчик отправки формы
	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		// Если есть ошибка, даем 300 мс, чтобы убрать ее
		if (errorMessage.length > 0) {
			hideMessagesAndLoaders();
			await new Promise((resolve) => setTimeout(resolve, 300));
		}
		if (isFormValid) {
			setIsLoading(true);
			// Делаем запрос
			const response = await loginRequest({ email, password });
			if (response.success && response.data) {
				navigate("/main");
			} else {
				setIsLoading(false);
				setErrorMessage(response.message ?? "Сталась невідома помилка");
				hideElement(loaderRef.current as HTMLElement);
				setTimeout(() => {
					showElement(messageRef.current as HTMLElement);
				}, 350);
			}
		}
	};
	// Скрыть сообщения и прелоадеры
	const hideMessagesAndLoaders = () => {
		hideElement(loaderRef.current as HTMLElement);
		hideElement(messageRef.current as HTMLElement);
		console.log("Сообщения и прелоадеры убраны");
	};

	// ---------------- Effects
	// Валидируем всю форму
	useEffect(() => {
		setIsFormValid(isEmailValid && password.length > 0);
	}, [password, isEmailValid]);
	// Показываем
	useEffect(() => {
		isLoading && showElement(loaderRef.current as HTMLElement);
	}, [isLoading]);

	return (
		<div className='login'>
			<h1 className='login__title'>Увійти</h1>
			<p className='login__subtitle'>Введіть email та пароль для входу</p>
			<form
				className={`login__form ${isLoading ? "loading" : ""}`}
				onSubmit={handleSubmit}>
				<div className='login__form-item'>
					<InputEmail
						value={email}
						onChange={(nextEmail, valid) => {
							setEmail(nextEmail);
							setIsEmailValid(valid);
						}}
					/>
				</div>
				<div className='login__form-item'>
					<InputPassword value={password} onChange={setPassword} />
				</div>
				<Button
					type='submit'
					unactive={!isEmailValid || password.length === 0}
					className='login__form-item-button'>
					Увійти
				</Button>
			</form>
			<div className='login__messages'>
				<div ref={loaderRef} className='login__loader'>
					<CircleLoader />
				</div>
				<div ref={messageRef} className='login__message'>
					<MainMessage type='error' text={errorMessage} />
				</div>
			</div>
		</div>
	);
};
